import { https , httpsFile } from './http.js';

export function index () {
    return https().get('material-group2');
}
export function getMatGrp2 (search,offset) {
    return https().get(`getMatGrp2?search=${search}&offset=${offset}`);
}